module.exports = __webpack_public_path__ + "static/media/subtitles.c06b9376.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PublicWebsite/Features/subtitles.svg
// module id = 515
// module chunks = 0